import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../../../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_lazysizesclient_d278759c from 'nuxt_plugin_lazysizesclient_d278759c' // Source: ./lazysizes.client.js (mode: 'client')
import nuxt_plugin_critical_796fb388 from 'nuxt_plugin_critical_796fb388' // Source: ../../../plugins/critical.server (mode: 'server')
import nuxt_plugin_focusvisible_771576d2 from 'nuxt_plugin_focusvisible_771576d2' // Source: ../../../plugins/focus-visible.client (mode: 'client')
import nuxt_plugin_fathom_4800be96 from 'nuxt_plugin_fathom_4800be96' // Source: ../../../plugins/fathom.client (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule
const baseStoreOptions = { preserveState: process.client }

function registerModule (path, rawModule, options = {}) {
  return originalRegisterModule.call(this, path, rawModule, { ...baseStoreOptions, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"htmlAttrs":{"lang":"en","dir":"ltr"},"title":"Right-Click → View Page Source","meta":[{"hid":"charset","charset":"utf-8","once":true},{"hid":"viewport","name":"viewport","content":"width=device-width, initial-scale=1","once":true},{"hid":"og:type","property":"og:type","content":"website","once":true},{"hid":"og:locale","property":"og:locale","content":"en_GB","once":true},{"hid":"og:site_name","property":"og:site_name","content":"Right-Click → View Page Source","once":true},{"hid":"twitter:site","name":"twitter:site","content":"@viewsourceio","once":true},{"hid":"twitter:creator","name":"twitter:creator","content":"@viewsourceio","once":true},{"hid":"flattr:id","name":"flattr:id","content":"6w26jk","once":true},{"hid":"monetization","name":"monetization","content":"$ilp.uphold.com\u002Fqx4MR4qXh9H3","once":true}],"link":[{"hid":"rss-feed","rel":"alternate","type":"application\u002Frss+xml","href":"\u002Ffeed.xml","title":"RSS Feed","once":true},{"hid":"fathom-dns-prefetch","rel":"dns-prefetch","href":"barnacle.viewsource.io","once":true},{"hid":"fathom-preconnect","rel":"preconnect","href":"barnacle.viewsource.io","once":true},{"hid":"mailto","rel":"me","href":"mailto:hello@iamsaul.co.uk","once":true},{"hid":"keybase.io","rel":"me","href":"https:\u002F\u002Fkeybase.io\u002Fsaulhardman","once":true},{"hid":"micro.blog","rel":"me","href":"https:\u002F\u002Fmicro.blog\u002Fsaul","once":true},{"hid":"twitter.com","rel":"me","href":"https:\u002F\u002Ftwitter.com\u002Fsaulhardman","once":true},{"hid":"mastodon.social","rel":"me","href":"https:\u002F\u002Fmastodon.social\u002F@saulhardman","once":true},{"hid":"github.com","rel":"me","href":"https:\u002F\u002Fgithub.com\u002Fsaulhardman","once":true},{"hid":"dev.to","rel":"me","href":"https:\u002F\u002Fdev.to\u002Fsaul","once":true},{"hid":"stackoverflow.com","rel":"me","href":"https:\u002F\u002Fstackoverflow.com\u002Fusers\u002F3081147\u002Fsaulhardman","once":true},{"hid":"pgpkey","rel":"pgpkey","type":"application\u002Fpgp-keys","href":"https:\u002F\u002Fkeybase.io\u002Fsaulhardman\u002Fpgp_keys.asc","once":true},{"hid":"webmention","rel":"webmention","href":"https:\u002F\u002Fwebmention.io\u002Fviewsource.io\u002Fwebmention","once":true},{"hid":"pingback","rel":"pingback","href":"https:\u002F\u002Fwebmention.io\u002Fviewsource.io\u002Fxmlrpc","once":true},{"hid":"apple-touch-icon","rel":"apple-touch-icon","sizes":"180x180","href":"\u002Ffavicons\u002Fapple-touch-icon.png","once":true},{"hid":"favicon-32x32","rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"\u002Ffavicons\u002Ffavicon-32x32.png","once":true},{"hid":"favicon-16x16","rel":"icon","type":"image\u002Fpng","sizes":"16x16","href":"\u002Ffavicons\u002Ffavicon-16x16.png","once":true},{"hid":"mask-icon","rel":"mask-icon","color":"#ffffff","href":"\u002Ffavicons\u002Fsafari-pinned-tab.svg","once":true},{"hid":"favicon","rel":"shortcut icon","href":"\u002Ffavicon.ico","once":true},{"hid":"fathom-js-preload","rel":"preload","href":"https:\u002F\u002Fbarnacle.viewsource.io\u002Fscript.js","as":"script","once":true}],"script":[{"hid":"fathom-js","src":"https:\u002F\u002Fbarnacle.viewsource.io\u002Fscript.js","site":"FVPOXLCN","included-domains":"viewsource.io","auto":false,"defer":true},{"hid":"lazysizes-config","innerHTML":"try {window.lazySizesConfig = JSON.parse('{\"init\":false}');} catch (error) {console.error('Failed to parse `window.lazySizesConfig`: ', error);window.lazySizesConfig = { init: false };}","once":true,"pbody":true}],"style":[],"__dangerouslyDisableSanitizersByTagID":{"lazysizes-config":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.client && typeof nuxt_plugin_lazysizesclient_d278759c === 'function') {
    await nuxt_plugin_lazysizesclient_d278759c(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_critical_796fb388 === 'function') {
    await nuxt_plugin_critical_796fb388(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_focusvisible_771576d2 === 'function') {
    await nuxt_plugin_focusvisible_771576d2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_fathom_4800be96 === 'function') {
    await nuxt_plugin_fathom_4800be96(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, (err) => {
        // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
        if (!err._isRouter) return reject(err)
        if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
